import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { HeaderPageSignalDataService } from '../header-page-signal-data.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-header-page',
  templateUrl: './header-page.component.html',
  styleUrls: ['./header-page.component.scss']
})
export class HeaderPageComponent implements OnInit {

  textVb: boolean = false;
  titleMenu: string | undefined;
  titlePage: string | undefined;
  subTitlePage: string | undefined;
  isShowBack: boolean = true;

  constructor(
    private router: Router,
    private location: Location,
    private activedRouted: ActivatedRoute,
    public headerPageSignalDataService: HeaderPageSignalDataService,
  ) { }

  ngOnInit() {
    this.routerEvent();
  }

  back() {
    this.resetHeader();
    this.location.back();
  }

  routerEvent() {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        this.isShowBack = !event.url.includes('home');
        return { event, route: this.rootRoute(this.activedRouted) };
      })
    ).subscribe((data: { event: NavigationEnd, route: ActivatedRoute }) => {
      if (data.route.snapshot.data?.['headerPage']) {
        this.titleMenu = data.route.snapshot.data?.['headerPage']?.sidac ? 'Sidac' : undefined;
        this.titlePage = data.route.snapshot.data?.['headerPage']?.titlePage;
        this.subTitlePage = data.route.snapshot.data?.['headerPage']?.subTitlePage;
      }
    });
  }

  private rootRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild)
      route = route.firstChild;
    return route;
  }

  resetHeader() {
    this.headerPageSignalDataService.updateVbTitlePage(false);
    this.headerPageSignalDataService.updateTitleMenu('');
    this.headerPageSignalDataService.updateTitlePage('');
    this.headerPageSignalDataService.updateEtapaSubTitlePage('');
    this.headerPageSignalDataService.updateSubTitlePage('');
  }
}
